import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import SegmentedControl from '../shared/SegmentedControl.svelte';
import Button from '../shared/Button.svelte';
import { openDonationCheckout } from '../../lib/services/stripe';

var root_1 = $.from_html(`<button> </button>`);
var root_2 = $.from_html(`<div class="custom-input-wrap svelte-svz74ngaz9mi"><span class="currency svelte-svz74ngaz9mi">$</span> <input type="number" class="custom-input svelte-svz74ngaz9mi" placeholder="Amount" min="1"/></div>`);
var root = $.from_html(`<div class="donate-sheet svelte-svz74ngaz9mi"><!> <div class="amount-grid svelte-svz74ngaz9mi"><!> <button>Custom</button></div> <!> <!> <p class="security-note svelte-svz74ngaz9mi"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="3" y="11" width="18" height="11" rx="2"></rect><path d="M7 11V7a5 5 0 0110 0v4"></path></svg> Secured by Stripe encryption</p></div>`);

function DonateSheet($$anchor, $$props) {
	$.push($$props, true);

	let donationType = $.state('one-time');
	let selectedAmount = $.state(10);
	let customAmount = $.state('');
	let showCustom = $.state(false);

	const typeOptions = [
		{ value: 'one-time', label: 'One-time' },
		{ value: 'monthly', label: 'Monthly' }
	];

	const presets = [5, 10, 25, 50];

	function selectPreset(amount) {
		$.set(selectedAmount, amount, true);
		$.set(showCustom, false);
		$.set(customAmount, '');
	}

	function selectCustom() {
		$.set(selectedAmount, null);
		$.set(showCustom, true);
	}

	const finalAmount = $.derived(() => $.get(selectedAmount) || parseFloat($.get(customAmount)) || 0);

	function handleDonate() {
		if ($.get(finalAmount) <= 0) return;

		openDonationCheckout($.get(finalAmount), $.get(donationType));
	}

	var div = root();
	var node = $.child(div);

	SegmentedControl(node, {
		get options() {
			return typeOptions;
		},

		get selected() {
			return $.get(donationType);
		},
		onchange: (v) => $.set(donationType, v, true)
	});

	var div_1 = $.sibling(node, 2);
	var node_1 = $.child(div_1);

	$.each(node_1, 17, () => presets, $.index, ($$anchor, amount) => {
		var button = root_1();
		let classes;
		var text = $.child(button);

		$.reset(button);

		$.template_effect(() => {
			classes = $.set_class(button, 1, 'amount-btn svelte-svz74ngaz9mi', null, classes, { selected: $.get(selectedAmount) === $.get(amount) });
			$.set_text(text, `$${$.get(amount) ?? ''}`);
		});

		$.delegated('click', button, () => selectPreset($.get(amount)));
		$.append($$anchor, button);
	});

	var button_1 = $.sibling(node_1, 2);
	let classes_1;

	$.reset(div_1);

	var node_2 = $.sibling(div_1, 2);

	{
		var consequent = ($$anchor) => {
			var div_2 = root_2();
			var input = $.sibling($.child(div_2), 2);

			$.remove_input_defaults(input);
			$.reset(div_2);
			$.bind_value(input, () => $.get(customAmount), ($$value) => $.set(customAmount, $$value));
			$.append($$anchor, div_2);
		};

		$.if(node_2, ($$render) => {
			if ($.get(showCustom)) $$render(consequent);
		});
	}

	var node_3 = $.sibling(node_2, 2);

	{
		let $0 = $.derived(() => $.get(finalAmount) <= 0);

		Button(node_3, {
			variant: 'primary',
			size: 'lg',
			fullWidth: true,
			onclick: handleDonate,
			get disabled() {
				return $.get($0);
			},

			children: ($$anchor, $$slotProps) => {
				$.next();

				var text_1 = $.text();

				$.template_effect(() => $.set_text(text_1, `Donate $${($.get(finalAmount) || '...') ?? ''}`));
				$.append($$anchor, text_1);
			},
			$$slots: { default: true }
		});
	}

	$.next(2);
	$.reset(div);
	$.template_effect(() => classes_1 = $.set_class(button_1, 1, 'amount-btn custom-btn svelte-svz74ngaz9mi', null, classes_1, { selected: $.get(showCustom) }));
	$.delegated('click', button_1, selectCustom);
	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	DonateSheet = $.hmr(DonateSheet);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-svz74ngaz9mi');
		DonateSheet[$.HMR].update(module.default);
	});
}

export default DonateSheet;

$.delegate(['click']);
import "bun-svelte:DonateSheet.svelte-3i3qhmbfxcowd-style.css";